export default __webpack_public_path__ + "static/media/mascote-cabeca.7687618e.webp";